import { schema } from "normalizr"

export default new schema.Entity("articleGroups", {}, { idAttribute: "articleGroupId" })
